/* src/app/graphview/graphview.component.css */
:host ::ng-deep .p-dialog.easDialog {
  border-radius: 8px;
  overflow: hidden;
}
:host ::ng-deep .p-dialog.easDialog .p-dialog-header {
  background: #fff;
  border-bottom: 1px solid #d3d3d3;
  padding: 12px 16px;
}
:host ::ng-deep .p-dialog.easDialog .p-dialog-title {
  color: #2b2b2b;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
}
:host ::ng-deep .p-dialog.easDialog .p-dialog-header-icons .p-dialog-header-icon {
  color: #89bf98;
}
:host ::ng-deep .p-dialog.easDialog .p-dialog-content {
  background: #fff;
  padding: 12px 16px;
}
.easDialogBody {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
}
.topRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.noData {
  padding: 10px 12px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  background: #f8f8f8;
}
.noData h3 {
  margin: 0;
  color: #6b6b6b;
  font-weight: 600;
}
:host ::ng-deep .typeSwitch .p-selectbutton .p-button {
  border-color: #9dcaae;
  color: #6b6b6b;
  background: #fff;
  border-radius: 6px;
}
:host ::ng-deep .typeSwitch .p-selectbutton .p-button.p-highlight {
  background: #9cc9ad;
  border-color: #9cc9ad;
  color: #fff;
}
:host ::ng-deep .typeSwitch .p-selectbutton .p-button:focus {
  box-shadow: none;
  border-color: #9cc9ad;
}
.dateRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.dateSep {
  color: #89bf98;
  font-weight: 600;
}
:host ::ng-deep .easCal .p-inputtext {
  border-color: #9dcaae;
  color: #6b6b6b;
  border-radius: 6px;
}
:host ::ng-deep .easCal .p-inputtext:focus {
  box-shadow: none;
  border-color: #9cc9ad;
}
:host ::ng-deep .easCal .p-datepicker-trigger {
  color: #89bf98;
}
.chartWrap {
  flex: 1 1 auto;
  min-height: 0;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  overflow: hidden;
  padding: 8px;
  background: #fff;
}
:host ::ng-deep .chartWrap canvas {
  max-height: 100% !important;
}
.dialogFooter {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
  border-top: 1px solid #d3d3d3;
}
.easBtn {
  background: transparent !important;
  border: 1px solid #9dcaae !important;
  color: #89bf98 !important;
  border-radius: 6px !important;
  padding: 6px 10px !important;
}
.easBtn .pi {
  margin-right: 8px;
  font-size: 14px;
}
.easBtn:hover {
  background: #f2fbf5 !important;
  border-color: #9cc9ad !important;
}
.easBtn:focus {
  box-shadow: none !important;
}
:host ::ng-deep .typeSwitch .p-selectbutton {
  display: flex;
  gap: 10px;
}
/*# sourceMappingURL=graphview.component.css.map */
